// components/Loader.jsx
import { motion, AnimatePresence } from 'framer-motion';
import { useEffect, useState } from 'react';
import Logo from './images/toplogo.png';

export default function Loader() {
  const [animateExit, setAnimateExit] = useState(false);
  const [show, setShow] = useState(true);

  useEffect(() => {
    const blinkTime = 1200;
    const moveTime = 800;

    const blinkTimeout = setTimeout(() => setAnimateExit(true), blinkTime);
    const finalTimeout = setTimeout(() => setShow(false), blinkTime + moveTime);

    return () => {
      clearTimeout(blinkTimeout);
      clearTimeout(finalTimeout);
    };
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[9999] bg-white flex items-center justify-center"
        >
          <motion.img
            src={Logo}
            alt="Logo"
            initial={{ scale: 1, opacity: 1 }}
            animate={{
              scale: animateExit ? 0.4 : 1,
              x: animateExit ? -window.innerWidth / 2 + 80 : 0,
              y: animateExit ? -window.innerHeight / 2 + 40 : 0,
              opacity: animateExit
                ? 1
                : [1, 0.4, 1, 0.4, 1], // Blink animation
            }}
            transition={{
              duration: animateExit ? 0.8 : 1.2,
              ease: 'easeInOut',
              times: animateExit ? undefined : [0, 0.25, 0.5, 0.75, 1],
            }}
            className="absolute w-32 h-32"
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
